import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import othersActions from "../../../redux/actions/others"
import { useFormik } from "formik";
import { useState } from "react";
import { lookupPhone } from "../../../libs/twilio";
import scheduleActions from "../../../redux/actions/schedule";
import { personalInputs } from "../../../data/inputs";
import axios from "../../../interceptor/ApiInterceptor";
import toast from "react-hot-toast";
import { MaterialIcon } from "../../../components/Icons"

export const useRegisterForm = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const user = useSelector(state => state.auth.user)
  const appointment = useSelector(state => state.schedule)
  const isLoading = useSelector(state => state.others.isLoading)

  const showLogin = useSelector(state => state.others.showLogin)
  const openLogin = () => {
    if(appointment?.patient?.idType && appointment?.patient?.idNumber) {
      navigate(`/login${`/${appointment?.patient?.idType}`}${`/${appointment?.patient?.idNumber}`}?/agenda/paciente`)
    } else {
      navigate(`/login?/agenda/paciente`)
    }
  }
  
  const patientSchema = Yup.object().shape({
    name: Yup.string().min(2, 'Escribe más de 2 carácteres como mínimo').max(50, 'Too Long!').required('Este campo es obligatorio'),
    surname: Yup.string().min(2, 'Escribe más de 2 carácteres como mínimo').max(50, 'Too Long!').required('Este campo es obligatorio'),
    idType: Yup.string().required('Este campo es obligatorio').oneOf(['DNI', 'PAS', 'CI']),
    phone: Yup.number().required('Este campo es obligatorio').min(1000000000, 'Este campo es obligatorio'),
    gender: Yup.string().required('Este campo es obligatorio'),

    mail: Yup.string().email('Verifica que sea un email válido').required('Este campo es obligatorio'),
    idNumber: Yup.string().when('idType', {
        is: "DNI",
        then: schema => schema.min(5, 'Tu DNI debe ser mayor o igual a 5 cifras').max(10, 'Tu DNI debe ser menor o igual a 8 cifras'),
      }).required('Este campo es obligatorio'),
    birthDate: Yup.string().required('Este campo es obligatorio').nullable()//.max(new Date(), 'La fecha declarada no puede ser posterior a hoy').min(new Date("01-01-1900"), "La fecha declarada debe ser posterior a 01/01/1900")
  });

  const [twilioError, setTwilioError] = useState("")
  const [documentValidation, setDocumentValidation] = useState({
    exist: true, searched: false, error: "", loading: false
  })

  const updatePatient = (values) => {
    dispatch(scheduleActions.updateAppointment({...appointment, patient: {...appointment?.patient, ...values}}))
  }


  const registrarUsuario = async (data) => {
    try {
      const url = `${process.env.REACT_APP_JAVA_BE_URL}/external/api/v2/addressschedule/registerBotmaker`;
      const response = await axios.post(url, data);
      if (response.status === 200) {
        toast({
          type: "success",
          title: `¡Usuario registrado correctamente!`,
          icon: <MaterialIcon icon="waving_hand" />
        });
      }
  
      return response.data;
    } catch (error) {
      console.error('Error al registrar:', error);
      toast({
        type: "warning",
        title: "Hubo un problema al registrar el usuario",
        icon: <MaterialIcon icon="error" /> // Podés cambiar el ícono si querés
      });
      throw error;
    }
  }

  const resetDocument = () => {
    setDocumentValidation({exist: true, searched: false, error: ""})
    updatePatient({idNumber: "", idType: ""})
  }

  const validateDocument = (values) => {
    
    setDocumentValidation({...documentValidation, loading: true})

    const url = `${process.env.REACT_APP_JAVA_BE_URL}/external/api/v1/security/prelogin`
    const payload = {idNumber: values?.idNumber, idType: values?.idType}

    axios.post(url, payload)
      .then(res => {
        const userToken = res.data.data

        if(userToken && userToken !== "") {
          setDocumentValidation({
            exist: true, 
            searched: true, 
            error: "Tu documento está asociado a una cuenta activa, para continuar", 
            loading: false
          })
        } else {
          setDocumentValidation({exist: false, searched: true, error: "", loading: false})
          updatePatient({...payload})
          setValuesInFormik()
        }
      })
      .catch(error => {
        console.log(error);

        if (error?.response?.status === 500) {
          setDocumentValidation({ exist: false, searched: true, error: "", loading: false })
          updatePatient({ ...payload })
          setValuesInFormik()
          return
        }

        setDocumentValidation({
          exist: true,
          searched: true,
          error: "Hubo un problema validando tu documento, vuelve a intentarlo nuevamente",
          loading: false,
        })
        updatePatient({ idNumber: "", idType: "" })
      })
  }
  const formikDocument = useFormik({
    initialValues: {
      idType: '',
      idNumber: '',
    },
    validationSchema: Yup.object({
      idType: Yup.string().required('Campo obligatorio'),
      idNumber: Yup.string().required('Campo obligatorio'),
    }),
    onSubmit: (values) => {
      validateDocument(values)
    },
  })
  
  const formikRegister = useFormik({
    initialValues: {
      name: '',
      surname: '',
      gender: '',
      birthDate: '',
      mail: '',
      phone: '',
      idType: appointment?.patient?.idType || '',
      idNumber: appointment?.patient?.idNumber || '',
    },
    validationSchema: patientSchema,
    onSubmit: async (values) => {
      console.log('Acáaaa')
      dispatch(othersActions.setIsLoading(true))
  
      const output = await lookupPhone(values.phone)
      if (!output?.mobile) {
        setTwilioError('Ingresá un número celular válido')
        dispatch(othersActions.setIsLoading(false))
        return
      }
  
      try {
        await registrarUsuario(values)
        setTimeout(() => dispatch(othersActions.setIsLoading(false)), 2000)
        navigate('/agenda/cobertura')
      } catch (err) {
        dispatch(othersActions.setIsLoading(false))
        console.error('Error al registrar:', err)
      }
    }
  })
  

  const setValuesInFormik = () => {
    formikRegister.setFieldValue('idType', appointment?.patient?.idType)
    formikRegister.setFieldValue('idNumber', appointment?.patient?.idNumber)
  }

  const loggedSubmit = () => {
    dispatch(scheduleActions.updateAppointment({...appointment, patient: user}))
    navigate('/agenda/')
  }

  return {
    appointment, 
    formikDocument,
    formikRegister, 
    // date, 
    inputs: personalInputs, 

    isLoading, 
    user, 
    navigate, 
    openLogin, 
    loggedSubmit,
    twilioError,
    documentValidation,
    validateDocument,
    resetDocument,
    updatePatient,
    registrarUsuario
  }
}
